import React, { Component } from 'react';
import { CommonlyHead } from '../common/headnav';
import { Toast, Button, 
    // Flex, Checkbox, Radio, List,
     Modal } from 'antd-mobile';
import * as services from '../projects/services';
import { createBrowserHistory } from "history";
import { AddAddress } from "../common/addAddress";
const history = createBrowserHistory();
// const AgreeItem = Checkbox.AgreeItem;
// const RadioItem = Radio.RadioItem;

export default class SAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cartlist: [],
            checkprice: 0,
            cnum: 0,
            showList: [],
            addlist: [],
            checkvalue: 0,
            modal1: false,
            cardidlist: '',
            breceipt: false,
            add:[],
        }
    }
    componentDidMount() {
        if (localStorage.getItem('cartlist') !== null) {
            let value = JSON.parse(localStorage.getItem('cartlist'));
            var map = {}, dest = [];
            let cmlist = value;
            let cardidlist = '';
            for (var i = 0; i < cmlist.length; i++) {
                if (i === cmlist.length - 1) {
                    cardidlist += cmlist[i].cartId;
                } else {
                    cardidlist += cmlist[i].cartId + ',';
                }

                var ai = cmlist[i];
                if (!map[ai.mcId]) { //依赖分组字段可自行更改！
                    dest.push({
                        id: ai.mcId, //依赖分组字段可自行更改！
                        mcName: ai.mcName,
                        data: [ai]
                    });
                    map[ai.mcId] = ai; //依赖分组字段可自行更改！
                } else {
                    for (var j = 0; j < dest.length; j++) {
                        var dj = dest[j];
                        if (dj.id === ai.mcId) { //依赖分组字段可自行更改！
                            dj.data.push(ai);
                            break;
                        }
                    }
                }
            }
            let checkprice = 0;
            value.forEach((data) => {
                checkprice += parseFloat(data.cartRealPrice) * parseInt(data.buyCount)
            })
            this.setState({ cartlist: value, checkprice: checkprice, cnum: value.length, showList: dest, cardidlist: cardidlist });
        }

        this.GetAddressList();


    }
    GetAddressList() {
        services.GetAddressList('').then(value => {
            if (value.status === 0) {
                value.result.forEach((data, index) => {
                    data['value'] = index;
                })
                this.setState({ addlist: value.result });
            } else {
                Toast.offline(value.message);
            }
        })
    }
    onChange = (value) => {
        this.setState({ checkvalue: value });
    }
    open = () => {
        this.setState({
            modal1: true,
        });
    }
    AddOrder = () => {
        let parameter = {
            breceipt: this.state.breceipt, carts: this.state.cardidlist, address: this.state.breceipt ? this.state.addlist[this.state.checkvalue].addressid : '',
            persons: '', bindids: '',
        };
        services.AddOrder(parameter, '确认套餐中').then((data) => {
            if (data.status === 0) {
                history.push(`/pay/${data.message}`);
                history.go();
            } else {
                Toast.offline(data.message);
            }
        });
    }
    onClose = () => {
        this.setState({
            modal1: false,
        });
        this.GetAddressList();
    }
    changBre = () => {
        let checkprice = this.state.checkprice;
        if (this.state.breceipt) {
            checkprice = parseFloat(checkprice - 6)
        } else {
            checkprice = parseFloat(checkprice + 6)
        }
        this.setState({ breceipt: !this.state.breceipt, checkprice: checkprice })
    }
    render() {
        return <div className="shopping">
            <CommonlyHead barname='核对订单' />
            <div className="cart2">
                {
                    this.state.showList.length <= 0 ? '' :
                        this.state.showList.map((value, index) => (
                            <div key={index}>
                                <div className="line"></div>
                                <div className="hospitalname">{value.mcName}</div>
                                {
                                    value.data.map((data, index2) => (
                                        <div className="cartbox" key={index2} >
                                            <div className="img" >
                                                {
                                                    data.picturePack === null ? <img src={require('../../res/images/h_zw.jpg')} alt="" /> : <img src={data.picturePack.length === 0 ? require('../../res/images/h_zw.jpg') : data.picturePack[0].picpath} alt="" />
                                                }
                                            </div>
                                            <div className="text"><div className="name"> {data.cartPackName}</div><div className="hprice">{data.cartRealPrice}</div></div>
                                            <div className="operate" >
                                                *{data.buyCount}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        ))
                }
                <div className="line"></div>
                </div>
            {/* <div className="billbox">
                <Flex>
                    <Flex.Item>
                        <AgreeItem checked={this.state.breceipt} data-seed="logId" onChange={e => this.changBre()}>
                            发票开具 (如需发票，邮费另付,默认韵达或申通，浙江省内邮费6元)
                        </AgreeItem>
                    </Flex.Item>

                </Flex>
                {
                    this.state.breceipt ?
                        <List >
                            {this.state.addlist.map(i => (
                                <RadioItem key={i.addressid} checked={this.state.checkvalue === i.value} onChange={() => this.onChange(i.value)}>
                                    {i.provincename}{i.cityname}{i.countyname}{i.adress}<span className="hprice">{i.consingee}</span><span className="hprice">{i.linktel}</span>
                                </RadioItem>
                            ))}

                            <Button className="madd" inline size="small" style={{ marginRight: '4px', marginLeft: '.5rem' }} onClick={() => this.open()}>新增收货地址</Button>
                        </List>
                        : ''
                }
            </div> */}
            <div className="footer">
                <div className="footerbox footerbox2">
                    <div className="fbigBtn settlementbox">
                        <div className="checkboxa">共<span className="hprice">{this.state.cnum}</span>件，应付<span className="hprice">{this.state.checkprice.toFixed(2)}</span></div>
                    </div>
                    <Button className="fbigBtn settlementBtn" onClick={this.AddOrder}>立即支付</Button>
                </div>
            </div>
            <Modal
                visible={this.state.modal1}
                transparent
                closable={true}
                maskClosable={true}
                onClose={this.onClose}
                wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            >
                <AddAddress onClose={this.onClose} data={this.state.add}  />
            </Modal>
        </div>;
    }
}